class CustomRegisterForm extends HTMLElement {
  constructor() {
    super();

    this.emailField = this.querySelector('[data-custom-newsletter-field]');

    // trigger button
    this.newSletterButton = this.querySelector('[data-custom-newsletter]');
    this.newSletterButton.addEventListener('click', () => {
      this.processNewsletter(this);
    });

    document.querySelector('[data-close]').addEventListener('click', function (e) {
      document.querySelector('body').classList.remove('active');
    });

    document.querySelector('#shopify-section-user-login').addEventListener('click', function (e) {
      if (!document.querySelector('custom-register-form').contains(e.target)) {
        document.querySelector('body').classList.remove('active');
      }
    });

    // triggers
    document.querySelectorAll('a[href*="#register-popup"]').forEach((link) => {
      link.addEventListener('click', function (e) {
        document.querySelector('body').classList.add('active');
      });
    });
  }

  /**
   * Process newsletter
   * @param {Event} event - The submit event
   */
  async processNewsletter(that) {
    that.isLoading(true);

    try {
      const valid = await this.validateField(this.emailField);

      // If there are errors in the form, throw an error
      if (!valid) throw new Error('There are errors in the form');
      await this.handleKlaviyoSubscription();
    } catch (err) {
      console.log('I have an error', err);
      this.toggleErrorMessage(true, err.message);
      this.scrollToError();
    } finally {
      this.isLoading(false);
    }
  }

  async validateField(field) {
    const { name, value, validity } = field;

    field.setAttribute('aria-invalid', !validity.valid);

    return validity.valid;
  }

  scrollToError() {
    const error = this.form.querySelector('input:invalid');
    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  isLoading(loading) {
    this.newSletterButton.classList.toggle('loading', loading);
  }

  async handleKlaviyoSubscription() {
    // check if profile exists
    const userData = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailField.value,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'WHDYgu',
            },
          },
        },
      },
    };

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(userData),
    };

    try {
      // If successful, create the client subscription
      const some = await fetch(
        'https://a.klaviyo.com/client/subscriptions?company_id=V9VmHt',
        options
      )
        .then((res) => {
          CF.ready(function () {
            // Find the first CF form on the page.
            let myForm = document.querySelector('form[data-cf-form]');
            let email = document.querySelector('.step-1').querySelector('input').value;
            myForm.cfForm.setFieldValue('email', email);
            document.querySelector('.step-1').classList.add('hidden');
            document.querySelector('.step-2').classList.add('flex');
            document.querySelector('.step-2').classList.remove('hidden');
            myForm.addEventListener('cf:form_submitted', function (e) {
              console.log('event', e);
              document.querySelector('.step-2 img').classList.add('hidden');
              document.querySelector('.step-2 h2.h4').classList.add('hidden');
              document.querySelector('.step-2 div.text-base').classList.add('hidden');
              document.querySelector('[data-copy-code]').addEventListener('click', (event) => {
                navigator.clipboard.writeText('MEMBER10');
              });
            });
          });
        })
        .catch((err) => console.error(err));
      console.log(some);
    } catch (error) {
      this.toggleErrorMessage(true, error.message);
    } finally {
      this.isLoading(false);
    }
  }

  /**
   * Toggles the error message.
   * @param {Boolean} show Whether to show the error message.
   * @param {String} message The error message.
   */
  toggleErrorMessage(show, message = '') {
    console.log('me has an error', message);
    // this.formErrorEl.classList.toggle('hidden', !show);
    // this.formErrorEl.textContent = message;
  }
}

if (!customElements.get('custom-register-form')) {
  customElements.define('custom-register-form', CustomRegisterForm);
}
